module.exports = __webpack_public_path__ + "img/title-2.aa2ab426.png";